<template>
    <console-content v-if="order" max-width="1280">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">구매 상세정보</v-col>
            <v-spacer/>
        </v-row>

        <v-card class="mx-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">
                <v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon>기본정보
                <v-spacer/>
                <span class="caption grey--text">주문번호</span>
                <v-divider vertical class="mx-2 my-1"/>
                <span class="body-2">{{ order.orderNo }}</span>
            </v-card-title>
            <v-divider/>
            <v-data-table :items="[order]" :headers="ordersHeaders" hide-default-footer disable-sort class="mx-1">
                <template v-slot:item.giftcard="{item}">
                    <v-row v-if="item.giftcard" align="center">
                        <v-col md="auto">
                            <v-img v-if="item.giftcard.thumb" :src="item.giftcard.thumb" max-width="96" max-height="96"></v-img>
                            <v-responsive v-else width="96" height="96">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col>
                            <div class="text-start">[{{ item.platform }}]</div>
                            <div class="text-start">{{ item.giftcard.name }}</div>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.sender="{item}">
                    <div>{{ item.sender.name }} [{{ item.sender.id }}]</div>
                    <div>{{ item.sender.phone.phoneNumberFormat() }}</div>
                    <div>{{ item.sender.email }}</div>
                </template>
                <template v-slot:item.faceamt="{item}">
                    {{ item?.faceamt?.format?.() }}
                </template>
                <template v-slot:item.quantity="{item}">
                    {{ item?.quantity?.format?.() }}
                </template>
                <template v-slot:item.salesAmount="{item}">
                    {{ item?.salesAmount?.format?.() }}
                </template>
                <template v-slot:item.mode="{item}">
                    <span v-if="item.mode == 'mobile'">모바일</span>
                    <span v-if="item.mode == 'paper'">지류</span>
                    <span v-if="item.mode == 'manual'">수동</span>
                </template>
                <template v-slot:item.orderedAt="{item}">
                    {{ $dayjs(item.orderedAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
                <template v-slot:item.status="{item}">
                    <v-select v-model="item.status" :items="statuses" hide-details dense />
                </template>
            </v-data-table>
        </v-card>

        <v-card class="mt-4">
            <v-card-title class="subtitle-2 font-weight-bold"><v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon>구매자 정보</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.sender.name" label="이름" placeholder=" " hide-details />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.sender.id" label="아이디" placeholder=" " hide-details />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.sender.phone.phoneNumberFormat()" label="연락처" placeholder=" " hide-details />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.sender.email" label="이메일" placeholder=" " hide-details />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-4">
            <v-card-title class="subtitle-2 font-weight-bold"><v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon>받는사람 정보</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.receiver.name" label="이름" placeholder=" " hide-details readonly />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.receiver.phone.phoneNumberFormat()" label="연락처" placeholder=" " hide-details readonly />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.receiver.email" label="이메일" placeholder=" " hide-details readonly />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col v-if="order.platform == 'soil'" cols="auto" class="py-0">
                <v-btn color="white" class="yellow--text px-2 ml-1" @click="zipDownload">
                    <v-icon class="mr-2">{{ mdiBarrel }}</v-icon>Soil다운로드
                </v-btn>
            </v-col>
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-card  class="mx-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">
                <v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon>발행정보
                <v-spacer/>
                <v-btn v-if="order.status == '주문완료'" small color="white" dark class="blue--text mr-2" @click="batch(order)"><v-icon small class="mr-2">{{ mdiWalletGiftcard }}</v-icon>전체 발행요청</v-btn>
                <!-- <v-btn v-if="order.cno && !order.refundedAt && !issues.find(issue => issue.refundedAt)" small color="white" dark class="red--text" @click="refund({ order })"><v-icon small class="mr-2">{{ mdiCashRefund }}</v-icon>전체 캐시환불</v-btn> -->
            </v-card-title>
            <v-divider/>
            <v-data-table :items="issues" :headers="issuesHeaders" class="mx-1">
                <template v-slot:item.no="{item}">
                    {{ issues.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.giftcard="{item}">
                    <v-row v-if="item.giftcard" align="center">
                        <v-col md="auto">
                            <v-img v-if="item.giftcard.thumb" :src="item.giftcard.thumb" max-width="96" max-height="56"></v-img>
                            <v-responsive v-else width="96" height="56">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col>
                            <div class="text-start">[{{ item.platform }}]</div>
                            <div class="text-start">{{ item.giftcard.name }}</div>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.sender="{item}">
                    <div>{{ item.sender.name }} [{{ item.sender.id }}]</div>
                    <div>{{ item.sender.phone.phoneNumberFormat() }}</div>
                    <div>{{ item.sender.email }}</div>
                </template>
                <template v-slot:item.faceamt="{item}">
                    {{ item?.faceamt?.format?.() }}
                </template>
                <template v-slot:item.quantity="{item}">
                    {{ item?.quantity?.format?.() }}
                </template>
                <template v-slot:item.salesAmount="{item}">
                    {{ item?.salesAmount?.format?.() }}
                </template>
                <template v-slot:item.mode="{item}">
                    <span v-if="item.mode == 'mobile'">모바일</span>
                    <span v-if="item.mode == 'paper'">지류</span>
                </template>
                <template v-slot:item.orderedAt="{item}">
                    {{ $dayjs(item.orderedAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
                <template v-slot:item.cancel="{item}">
                    <v-btn v-if="(item.status == '발권완료' || (item.status != '취소완료' && item.platform == 'soil'))" small color="white" dark class="red--text" @click="cancel({ issue: item })"><v-icon small class="mr-2">{{ mdiCloseCircleOutline }}</v-icon>발권취소</v-btn>
                </template>
                <!-- <template v-slot:item.refund="{item}">
                    <v-btn v-if="item.cno && !item.refundedAt && order.status != '취소완료'" small color="white" dark class="red--text" @click="refund({ issue: item })"><v-icon small class="mr-2">{{ mdiCashRefund }}</v-icon>캐시환불</v-btn>
                </template> -->
                <template v-slot:item.note="{item}">
                    <div class="text-end">
                        <p class="d-inline-block">{{ item.note }}</p>
                        <v-icon small @click="note(item)" class="d-inline-block ml-2">mdi-pencil</v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <v-card v-if="order.mode == 'paper'" class="mx-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">
                <v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon>발행정보
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" md="3">
                        <v-autocomplete v-model="order.courier" :items="couriers" label="배송업체" placeholder=" " hide-edtails />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="order.invoiceNumber" label="운송장번호" placeholder=" " hide-edtails />
                    </v-col>
                    <!-- <v-col md="3">
                        <v-text-field v-model="order.cno" label="캐시승인번호" placeholder=" " hide-details class="ma-0 pa-0"></v-text-field>
                    </v-col> -->
                    <v-col cols="auto">
                        <v-btn v-if="order.cno && !order.refundedAt" small color="white" dark class="red--text" @click="refund({ order })"><v-icon small class="mr-2">{{ mdiCashRefund }}</v-icon>캐시환불s</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

        <note-dialog ref="noteDialog"></note-dialog>

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMinusThick, mdiCloseCircleOutline, mdiCashRefund, mdiWalletGiftcard, mdiBarrel, mdiMicrosoftExcel } from '@mdi/js';
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import NoteDialog from "@/components/console/shop/orders/note-dialog.vue";
import download from "downloadjs";

export default {
    components: {
        ConsoleContent,
        NoteDialog
    },
    data(){
        return {
            download,

            mdiMinusThick,
            mdiCloseCircleOutline,
            mdiCashRefund,
            mdiWalletGiftcard,
            mdiMicrosoftExcel,
            mdiBarrel,

            showSearch: true,

            order: null,
            ordersHeaders: [
                { text: "상품권", value: "giftcard", align: "center" },
                { text: "권종", value: "faceamt", align: "center" },
                { text: "수량", value: "quantity", align: "center" },
                { text: "주문구분(수동)", value: "mode", align: "center" },
                { text: "상태", value: "status", width: 140, align: "center" },
            ],

            statuses: ["주문완료", "발권요청", "발권완료", "취소요청", "취소불가", "취소완료", "부분취소완료", "배송중", "배송완료"],

            issues: [],
            issuesHeaders: [
                { text: "no", value: "no", align: "center" },
                { text: "발권주문번호", value: "ino", align: "center", width: 150 },
                { text: "발권승인번호", value: "tno", align: "center", width: 150 },
                // { text: "캐시승인번호", value: "cno", align: "center", width: 150 },
                { text: "발권상태", value: "status", align: "center", width: 100 },
                { text: "발권취소", value: "cancel", align: "center", width: 100, sortable: false },
                // { text: "캐시환불", value: "refund", align: "center", width: 100, sortable: false },
                { text: "메모", value: "note", align: "center", width: 400, sortable: false },
            ],

            couriers: [ "대한통운", "로젠택배", "아주택배", "옐로우캡", "우체국택배", "이젠택배", "트라넷", "한진택배", "현대택배", "훼미리택배", "Bell Express", "CJ GLS", "HTH", "KGB택배", "KT로지스택배" ]
            
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { order } = await api.console.shop.orders.get({ _id: this.$route.params._order });
            this.order = order;

            await this.search();
        },

        async search(){
            let { issues } = await api.console.shop.orders.issues.gets(this.order._id, {
                headers: { limit: 0 }
            });
            this.issues = issues;
        },

        async save(){
            await api.console.shop.orders.put(this.order);
            alert("저장되었습니다");
            this.$router.go(-1);
        },

        async cancel({ issue }){
            if(issue){
                let { issue: latest } = await api.console.shop.orders.issues.cancel(this.order._id, issue._id);
                this.$set(this.issues, this.issues.indexOf(issue), latest );
            }
        },

        async batch(order){
            await api.console.shop.orders.batch(order);
            this.order.status = "발권요청";
            alert("발권요청 되었습니다");
        },

        async refund({ order, issue }){
            console.log(order, issue)
            if(issue?.status === "발권완료") return alert("상품권의 발권취소 먼저 진행해주세요")
            if(order){
                if(order.status === "발권완료") return alert("상품권의 발권취소 먼저 진행해주세요")
                let { order: latest } = await api.console.shop.orders.refund(order);
                this.init();
            }

            if(issue){
                let { issue: latest } = await api.console.shop.orders.issues.refund(this.order._id, issue._id);
                this.init();
            }
        },

        note(issue){
            this.$refs.noteDialog.issue = issue;
            this.$refs.noteDialog.open();
        },

        excel(){
            let rows = []
            this.issues.forEach(issue => {

                rows.push({
                    "발권주문번호": issue?.ino,
                    "받는사람(연락처)": issue?.receiver?.phone,
                    "승인번호": issue?.tno,
                    "핀번호": issue?.pno,
                    "상태": issue?.status,
                    "인증번호(도서문화상품권)": issue?.pin?.certificationNo,
                    "발행일자(해피머니)": issue?.pin?.issueNo,
                })
            })
            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "핀목록.xlsx");
        },


        async zipDownload(){
            let { zipPath } = await api.console.shop.orders.zips.gets(this.order._id)

            api.getResource(zipPath).then(file => download(file, "soil.zip"))
        }
    }
} 
</script>